import React, { useState, useEffect } from "react";
import { useHistory } from 'react-router-dom';
import { NavLink } from "react-bootstrap";
import ConfirmDeleteModal from './ConfirmationModelDelete';
import './List.css'; // Import the CSS file
import axios from 'axios'; // Import Axios for API calls

const ListProductCategory = () => {
  const [showModal, setShowModal] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');
  const [userData, setUserData] = useState([]); // State for user data
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [limit] = useState(10); // Number of users per page
  const history = useHistory();
  const token = localStorage.getItem('authToken');

  const fetchUserData = async () => {
    try {
      const response = await axios.get(`https://brand.aasmo.in/api/admin/getall-category?page=${currentPage}&limit=${limit}&search=${searchQuery}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response) {
        setUserData(response.data.categories);
        setTotalPages(response.data.totalPages);
      } else {
        console.log("Error getting List");
      }
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  };

  const handleDownloadCSV = () => {
    const headers = [
      'S.No',
      'Category Name',
      'Store Name',
      'Store Area',
      'Description',
      'Date'
    ];
  
    const csvRows = [];
    csvRows.push(headers.join(',')); // Add headers as the first row
  
    userData.forEach((category, index) => {
      const storeNames = category?.brands?.map(brand => brand.name).join('; ') || 'N/A';
      const storeArea = category?.brands?.map(brand => brand.location).join('; ') || 'N/A';
      const description = category?.description || 'N/A';
      const formattedDate = formatDate(category?.createdAt);
  
      const row = [
        (currentPage - 1) * limit + index + 1, // Serial number
        category?.categoryName || 'N/A',      // Category Name
        storeNames,                           // Store Name(s)
        storeArea,                       // Store Location(s)
        description,                          // Description
        formattedDate                         // Formatted Date
      ];
  
      csvRows.push(row.join(',')); // Add the row to CSV rows
    });
  
    const csvBlob = new Blob([csvRows.join('\n')], { type: 'text/csv' });
    const csvUrl = URL.createObjectURL(csvBlob);
    const link = document.createElement('a');
    link.href = csvUrl;
    link.download = 'category_list.csv';
    link.click();
  };
  
  const handleEdit = (id) => {
    console.log(id, "id")
    history.push(`/edit-product-category/${id}`);
  };

  const handleDelete = async (id) => {
    try {
      const response = await axios.delete(`https://brand.aasmo.in/api/admin/delete-category/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response) {
        console.log("Deleted Successfully");
        fetchUserData(); // Refresh data after deletion
      }
    } catch (error) {
      console.log(error);
    }
    setShowModal(false); // Close modal after deletion
  };

  const handleDeleteClick = (id) => {
    setSelectedUserId(id);
    setShowModal(true);
  };

  const formatDate = (dateString) => {
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
    setCurrentPage(1); // Reset to the first page on new search
  };
  const handleStatusChange = async (id, currentStatus) => {
    const newStatus = currentStatus === 'active' ? 'inactive' : 'active';
    try {
      await axios.put(`https://brand.aasmo.in/api/admin/update-deals/${id}`, { status: newStatus }, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        }
      });
      fetchUserData()
    } catch (error) {
      console.error('Error updating status:', error);
    }
  };
  const truncatedDescription = (description) => {
    const words = description.split(' '); // Split the description into words
    if (words.length <= 5) {
      return description; // Return the full description if it's 5 words or less
    }
    return words.slice(0, 5).join(' ') + '...'; // Join the first 5 words and add "..."
  };

  // Fetch user data from API
  useEffect(() => {


    fetchUserData();
  }, [currentPage, limit, searchQuery]); // Dependencies
  return (
    <div className="col-lg-12">
      <div className="card">
        <div className="header">
          <h2>List</h2>
        </div>
        <div className="body">
          {/* Search Input */}
          <div className="d-flex justify-content-between">
          <div className="search-bar">
            <input
              type="text"
              placeholder="Search by Category Name"
              value={searchQuery}
              onChange={handleSearch}
            />
          </div>
          <div>
       <button onClick={handleDownloadCSV} className="btn btn-primary">
            Download CSV
          </button>
          </div>
       </div>
          <div className="table-responsive">
            <table className="table table-hover">
              <thead style={{ textAlign: "center", whiteSpace: "nowrap" }}>
                <tr>
                  <th>#</th>
                  <th> Category Name</th>
                  {/* <th> Store Name</th>
                  <th> Store 
                    Area
                  </th> */}
                  <th>  Description</th>
                  <th>Date</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody style={{ textAlign: "center" }}>
                {userData?.map((user, index) => (
                  <tr key={user?.id}>
                    <td>{index + 1}</td>

                    <td>{user?.categoryName}</td>

                    {/* <td>
                      {user?.brands?.map((brand, index) => (
                        <div key={index}>{brand.name}</div>
                      ))}
                    </td>
                    <td>
                      {user?.brands?.map((brand, index) => (
                        <div key={index}>{brand.area}</div>
                      ))}
                    </td> */}
                    <td>{user?.description}</td>
                    <td>{formatDate(user.createdAt)}</td>
                    <td>
                      <i className="icon-pencil" onClick={(e) => handleEdit(user?._id)}></i>

                      &nbsp;&nbsp;
                      <i className="fa fa-trash-o" onClick={() => handleDeleteClick(user?._id)}></i>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Pagination Controls */}
          <div className="body">
            <nav aria-label="Page navigation example" style={{ display: 'flex', justifyContent: 'center' }}>
              <ul className="pagination">
                <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                  <NavLink
                    to="#"
                    className="page-link"
                    onClick={() => handlePageChange(currentPage - 1)}
                  >
                    Previous
                  </NavLink>
                </li>
                {[...Array(totalPages).keys()].map(page => (
                  <li key={page} className={`page-item ${currentPage === page + 1 ? 'active' : ''}`}>
                    <NavLink
                      to="#"
                      className="page-link"
                      onClick={() => handlePageChange(page + 1)}
                    >
                      {page + 1}
                    </NavLink>
                  </li>
                ))}
                <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                  <NavLink
                    to="#"
                    className="page-link"
                    onClick={() => handlePageChange(currentPage + 1)}
                  >
                    Next
                  </NavLink>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>
      <ConfirmDeleteModal
        show={showModal}
        handleClose={() => setShowModal(false)}
        handleConfirm={() => handleDelete(selectedUserId)}
      />
    </div>
  );
};

export default ListProductCategory;
